import React from 'react';
// @ts-ignore
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalDialog,
    ModalHeader,
    ModalFooter,
    Link,
    Loader,
} from 'arag-ui-lib';
import WithdrawClaimApplicationForm from '../withdrawClaimApplicationForm/withdrawClaimApplicationForm';
import WithdrawnClaimApplicationBody from '../withdrawnClaimApplicationBody/withdrawnClaimApplicationBody';
import {
    PrimaryButton,
    SecondaryButton,
    SmallModal,
} from '../../hosc/modals/modals';
import generalStyles from '../../assets/styles/generalStyle.module.scss';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
type Props = {
    isWithdrawnModalOpen: boolean;
    closeWithdrawModal: () => void;
    claimApplication: { claimReference: string; withdrawn: boolean };
    submittingWithdrawnClaim: boolean;
    withDrawQuestions: any;
    questionTypes: any;
    onSubmitWithDrawnClaimApplication: any;
};
const WithdrawClaimApplicationModal = (props: Props): JSX.Element => {
    const {
        isWithdrawnModalOpen,
        closeWithdrawModal,
        claimApplication,
        submittingWithdrawnClaim,
        withDrawQuestions,
        questionTypes,
        onSubmitWithDrawnClaimApplication,
    } = props;
    const { t } = useTranslation();
    return (
        <Modal
            id={'withdraw_claim_modal'}
            fadeIn={isWithdrawnModalOpen}
            darkenedBackground
            noScroll
        >
            <ModalDialog id={'withdraw_claim_dialog'} size={'sm'}>
                <div
                    className={
                        claimApplication.withdrawn
                            ? generalStyles['fit-content-modal']
                            : ''
                    }
                >
                    <ModalContent id={'withdraw_claim_content'}>
                        <ModalHeader
                            id={'withdraw_claim_header'}
                            title={
                                !claimApplication.withdrawn
                                    ? t('withdrawClaimApplication')
                                    : null
                            }
                            onClose={closeWithdrawModal}
                        />
                        <Formik
                            initialValues={{}}
                            onSubmit={onSubmitWithDrawnClaimApplication}
                            validateOnBlur={false}
                            validateOnChange={false}
                        >
                            {formikProps => {
                                return (
                                    <Form
                                        className="form-horizontal"
                                        autoComplete="off"
                                        autoCorrect="off"
                                        spellCheck="true"
                                    >
                                        <ModalBody
                                            id={'withdraw_claim_body_wrapper'}
                                        >
                                            {!claimApplication.withdrawn ? (
                                                <WithdrawClaimApplicationForm
                                                    questionTypes={
                                                        questionTypes
                                                    }
                                                    withDrawQuestions={
                                                        withDrawQuestions
                                                    }
                                                    claimReference={
                                                        claimApplication.claimReference
                                                    }
                                                />
                                            ) : (
                                                <WithdrawnClaimApplicationBody
                                                    claimReference={
                                                        claimApplication.claimReference
                                                    }
                                                />
                                            )}
                                        </ModalBody>
                                        <ModalFooter>
                                            <SmallModal>
                                                <SecondaryButton>
                                                    {!claimApplication.withdrawn ? (
                                                        <div>
                                                            <Link
                                                                type="button"
                                                                variant="tertiary"
                                                                arrowDirection="left"
                                                                label={`${t('cancel')}`}
                                                                onClick={
                                                                    closeWithdrawModal
                                                                }
                                                            />
                                                            {submittingWithdrawnClaim && (
                                                                <Loader
                                                                    variant="inline"
                                                                    label={`${t('updating')}`}
                                                                />
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <Button
                                                            variant={'primary'}
                                                            label={`${t('ok')}`}
                                                            arrowDirection="left"
                                                            type={'button'}
                                                            onClick={
                                                                closeWithdrawModal
                                                            }
                                                        />
                                                    )}
                                                </SecondaryButton>
                                                <PrimaryButton>
                                                    {!claimApplication.withdrawn ? (
                                                        <Button
                                                            variant={'primary'}
                                                            label={`${t('withdrawClaim')}`}
                                                            type={'submit'}
                                                            arrowDirection="left"
                                                            disabled={
                                                                Object.values(
                                                                    formikProps.values,
                                                                ) &&
                                                                Object.values(
                                                                    formikProps.values,
                                                                ).filter(
                                                                    item =>
                                                                        item !==
                                                                        '',
                                                                ).length === 0
                                                            }
                                                        />
                                                    ) : null}
                                                </PrimaryButton>
                                            </SmallModal>
                                        </ModalFooter>
                                    </Form>
                                );
                            }}
                        </Formik>
                    </ModalContent>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default WithdrawClaimApplicationModal;
